import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../../services/message-observable.service';
import { RentaNoLaboralComercianteModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-comerciante-modal/renta-no-laboral-comerciante-modal.component';
import { RentaNoLaboralInmueblesModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-inmuebles-modal/renta-no-laboral-inmuebles-modal.component';
import { RentaNoLaboralAccionesModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-acciones-modal/renta-no-laboral-acciones-modal.component';
import { RentaNoLaboralActivosModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-activos-modal/renta-no-laboral-activos-modal.component';
import { RentaNoLaboralUtilidadesLiquidacionModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-utilidades-liquidacion-modal/renta-no-laboral-utilidades-liquidacion-modal.component';
import { RentaNoLaboralEximidosPrestamosModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-eximidos-prestamos-modal/renta-no-laboral-eximidos-prestamos-modal.component';
import { RentaNoLaboralEximidosDeudasModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-eximidos-deudas-modal/renta-no-laboral-eximidos-deudas-modal.component';
import { RentaNoLaboralRecompensasModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-recompensas-modal/renta-no-laboral-recompensas-modal.component';
import { RentaNoLaboralIndemnizacionesModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-indemnizaciones-modal/renta-no-laboral-indemnizaciones-modal.component';
import { RentaNoLaboralIngresosAnterioresModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-ingresos-anteriores-modal/renta-no-laboral-ingresos-anteriores-modal.component';
import { RentaNoLaboralHoteleraModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-hotelera-modal/renta-no-laboral-hotelera-modal.component';
import { RentaNoLaboralOtrosIngresosModalComponent } from '../modales/renta-no-laboral/renta-no-laboral-otros-ingresos-modal/renta-no-laboral-otros-ingresos-modal.component';


const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions:Question[] = [
  {question: 'Durante 2022 ¿Usted fue comerciante, ganadero, agricultor, ejerció como notario, curador urbano o tuvo otras actividades por delegación del Estado?', field: 'cs_id_478', show:true, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'Durante 2022 ¿Usted vendió activos fijos (bienes inmuebles) como casas, lotes, fincas, apartamentos, que fueron de su propiedad por menos de dos años?', field: 'cs_id_480', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'Durante 2022 ¿Usted vendió acciones o cuotas por menos de  dos años?', field: 'cs_id_481', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'Durante 2022 ¿Usted vendió activos fijos diferentes a los anteriores, que fueron de su propiedad por menos de 2 años?', field: 'cs_id_487', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: '¿Usted tuvo utilidades en liquidación de alguna sociedad constituida por menos de dos años de la cual fue socio o participe?', field: 'cs_id_491', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted fue eximido de préstamos educativos otorgados por el ICETEX o por terceros con recursos del Estado?', field: 'cs_id_494', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted fue eximido de la deuda de un crédito o préstamo para libre inversión, hipotecario, de consumo o educativo (diferentes al ICETEX o terceros con recursos del Estado)?', field: 'cs_id_496', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted recibió ingresos por recompensas o por donaciones a campañas políticas?', field: 'cs_id_498', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: '¿Usted recibió indemnizaciones por seguros en 2022, que no hayan sido seguros de vida?', field: 'cs_id_500', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'Durante el 2022 ¿usted recibió ingresos por rentas hoteleras(exentas)?', field: 'cs_id_802', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted recibió ingresos diferentes de todos los anteriores (rentas de trabajo, honorarios, compensaciones de servicios, rentas de capital) en Colombia o en el exterior?', field: 'cs_id_713', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: '¿Usted reportó ingresos por los conceptos anteriores?', field: 'cs_id_667', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  
];

@Component({
  selector: 'app-renta-no-laboral',
  templateUrl: './renta-no-laboral.component.html',
  styleUrls: ['./renta-no-laboral.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class RentaNoLaboralComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService

  ) { 
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);   
    this.validateComponentCompleted();
  }

  validateQuestions(id: number) {
    console.log(id);

  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
     
    });
  }

  initilizeQuestionsDesdeModelo(model){
    for(let i=0; i<questions.length; i++){
      switch(i){
        case 0:
          questions[i].resp = model.doc.cuerpo.cs_id_478  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_478 != undefined && model.doc.cuerpo.cs_id_478 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_478 == "1"){questions[i].show = true;}
          break;
        case 1:
          questions[i].resp = model.doc.cuerpo.cs_id_480  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_480 != undefined && model.doc.cuerpo.cs_id_480 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_480 == "1"){questions[i].show = true;}
          break;
        case 2:
          questions[i].resp = model.doc.cuerpo.cs_id_481  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_481 != undefined && model.doc.cuerpo.cs_id_481 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_481 == "1"){questions[i].show = true;}
          break;
        case 3:
          questions[i].resp = model.doc.cuerpo.cs_id_487 
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_487!= undefined && model.doc.cuerpo.cs_id_487=="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_487== "1"){questions[i].show = true;}
          break;
        case 4:
          questions[i].resp = model.doc.cuerpo.cs_id_491  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_491 != undefined && model.doc.cuerpo.cs_id_491 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_491 == "1"){questions[i].show = true;}
          break;
        case 5:
          questions[i].resp = model.doc.cuerpo.cs_id_494  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_494 != undefined && model.doc.cuerpo.cs_id_494 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_494 == "1"){questions[i].show = true;}
          break;
        case 6:
          questions[i].resp = model.doc.cuerpo.cs_id_496  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_496 != undefined && model.doc.cuerpo.cs_id_496 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_496 == "1"){questions[i].show = true;}
          break;
        case 7:
          questions[i].resp = model.doc.cuerpo.cs_id_498  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_498 != undefined && model.doc.cuerpo.cs_id_498 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_498 == "1"){questions[i].show = true;}
          break;
        case 8:
          questions[i].resp = model.doc.cuerpo.cs_id_500  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_500 != undefined && model.doc.cuerpo.cs_id_500 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_500 == "1"){questions[i].show = true;}
          break;
        case 9:
          questions[i].resp = model.doc.cuerpo.cs_id_802  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_802 != undefined && model.doc.cuerpo.cs_id_802 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_802 == "1"){questions[i].show = true;}
          break;
        case 10:
          questions[i].resp = model.doc.cuerpo.cs_id_713
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_713 != undefined && model.doc.cuerpo.cs_id_713 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_713 == "1"){questions[i].show = true;}
          break;
        case 11:
          questions[i].resp = model.doc.cuerpo.cs_id_667  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_667 != undefined && model.doc.cuerpo.cs_id_667 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_667 == "1"){questions[i].show = true;}
          break;
          
      
      }
      this.checkNextQuestion(i);
    }
    
  }

  openModal(indexQuestionModal:number) {
    const config = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    switch (indexQuestionModal) {
      case 0:
        let dialog0 = this.dialog.open(RentaNoLaboralComercianteModalComponent, config);
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 1:
        let dialog1 = this.dialog.open(RentaNoLaboralInmueblesModalComponent, config);
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 2:
        let dialog2 = this.dialog.open(RentaNoLaboralAccionesModalComponent, config);
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;  
      case 3:
        let dialog3 = this.dialog.open(RentaNoLaboralActivosModalComponent, config);
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 4:
        let dialog4 = this.dialog.open(RentaNoLaboralUtilidadesLiquidacionModalComponent, config);
        dialog4.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog4.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 5:
        let dialog5 = this.dialog.open(RentaNoLaboralEximidosPrestamosModalComponent, config);
        dialog5.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog5.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 6:
        let dialog6 = this.dialog.open(RentaNoLaboralEximidosDeudasModalComponent, config);
        dialog6.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog6.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 7:
        let dialog7 = this.dialog.open(RentaNoLaboralRecompensasModalComponent, config);
        dialog7.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog7.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 8:
        let dialog8 = this.dialog.open(RentaNoLaboralIndemnizacionesModalComponent, config);
        dialog8.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog8.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 9:
        let dialog9 = this.dialog.open(RentaNoLaboralHoteleraModalComponent, config);
        dialog9.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog9.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
        case 10:
        let dialog10 = this.dialog.open(RentaNoLaboralOtrosIngresosModalComponent, config);
        dialog10.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog10.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
        case 11:
          let dialog11 = this.dialog.open(RentaNoLaboralIngresosAnterioresModalComponent, config);
          dialog11.componentInstance.saveModel.subscribe(() => {
            this.saveModel.emit(true);
          });
          dialog11.afterClosed().subscribe(data => {
            this.validateModalCompleted(indexQuestionModal);
            console.log(data);
          });
          break;
    }
    
    
  }

  protected validateModalCompleted(indexQuestion:number):boolean{
    let isModalComplete:boolean = false;
    switch(indexQuestion){
      case 0://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_545, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 1://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_546, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 2://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_547, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 3://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_548, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 4://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_549, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 5://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_550, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 6://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_551, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 7://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_552, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 8://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_553, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 9://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_715, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
        case 10://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_807, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
    
        case 11://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_554, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
    

    
      default:
        break;
    }
    if(isModalComplete){
      questions[indexQuestion].isCompleted = true;
      if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    }else{
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }
  
  protected validateHasModalValues(indexQuestion:number):boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){
      case 0://Modal 
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_479, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_531, "0")){
          hasValues=true;break;
        }
        break;
      case 1://Modal 
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_482, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_486, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_678, "0")){
          hasValues=true;break;
        }
        
        
        break;
      case 2://Modal 
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_483, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_485, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_538, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_679, "0")){
          hasValues=true;break;
        }
        break;
      case 3://Modal 
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_488, "0")){
        hasValues=true;break;
      }
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_489, "0")){
        hasValues=true;break;
      }
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_663, "0")){
        hasValues=true;break;
      }
        break;
      case 4://Modal 
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_942, "0")){
        hasValues=true;break;
      }
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_493, "0")){
        hasValues=true;break;
      }
        break;
      case 5://Modal 
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_495, "0")){
          hasValues=true;break;
        }
        break;
      case 6://Modal
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_497, "0")){
          hasValues=true;break;
        }
        break;
      case 7://Modal
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_499, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_501, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_502, "0")){
          hasValues=true;break;
        }
       
        break;
      case 8://Modal
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_780, "0")){
          hasValues=true;;
        }

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_781, "0")){
          hasValues=true;;
        }
        break;
     case 9://Modal
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_804, "0")){
          hasValues=true;break;
        }
        break;
        case 10://Modal
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_714, "0")){
          hasValues=true;break;
        }
        break;
        case 11://Modal
        if(this.model.doc.cuerpo.cs_id_503 || this.model.doc.cuerpo.cs_id_513 || this.model.doc.cuerpo.cs_id_528){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_504, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_508, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_509, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_510, "0")){
          hasValues=true;break;
        }

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_511, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_512, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_514, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_515, "0")){
          hasValues=true;break;
        }

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_516, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_517, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_518, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_519, "0")){
          hasValues=true;break;
        }

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_520, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_521, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_522, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_526, "0")){
          hasValues=true;break;
        }

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_527, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_523, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_524, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_525, "0")){
          hasValues=true;break;
        }

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_529, "0")){
          hasValues=true;break;
        }
        break;
   
      default:
        return false;
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 0:
        this.model.doc.cuerpo.cs_id_479="0";
        this.model.doc.cuerpo.cs_id_531="0";
        this.model.doc.cuerpo.cs_id_545="0";//Indicador de Completo comerciante
        

        break;
      case 1:
        this.model.doc.cuerpo.cs_id_482="0";
        this.model.doc.cuerpo.cs_id_486="0";
        this.model.doc.cuerpo.cs_id_678="0";
        this.model.doc.cuerpo.cs_id_546="0"; //stepper inmuebles
        this.model.doc.cuerpo.cc_id_901=[];
        this.model.doc.cuerpo.cc_id_884=[];
        this.model.doc.cuerpo.cc_id_879=[];
        this.model.doc.cuerpo.cc_id_881=[];		
        this.model.doc.cuerpo.cc_id_880=[];	
        this.model.doc.cuerpo.cc_id_882=[];	
        this.model.doc.cuerpo.cc_id_902=[];	
        this.model.doc.cuerpo.cc_id_885=[];	
        this.model.doc.cuerpo.cc_id_883=[];	  
        this.model.doc.cuerpo.cc_id_903=[];	
        this.model.doc.cuerpo.cc_id_886=[];	
        this.model.doc.cuerpo.cc_id_887=[];	    
        break;
      case 2:
        this.model.doc.cuerpo.cs_id_483="0";
	    	this.model.doc.cuerpo.cs_id_485="0";
		    this.model.doc.cuerpo.cs_id_538="0";
		    this.model.doc.cuerpo.cs_id_679="0";
			this.model.doc.cuerpo.cc_id_895=[];
			this.model.doc.cuerpo.cc_id_889=[];
			this.model.doc.cuerpo.cc_id_888=[];		
			this.model.doc.cuerpo.cc_id_894=[];	
			this.model.doc.cuerpo.cc_id_893=[];	
			this.model.doc.cuerpo.cc_id_890=[];	
			this.model.doc.cuerpo.cc_id_891=[];	
			this.model.doc.cuerpo.cc_id_892=[];	
			this.model.doc.cuerpo.cc_id_900=[];	
        
        this.model.doc.cuerpo.cs_id_547="0";//Indicador de Completo Acciones
        break;  
      case 3:
        this.model.doc.cuerpo.cs_id_488="0";
        this.model.doc.cuerpo.cs_id_489="0";
        this.model.doc.cuerpo.cs_id_663="0";
    
            this.model.doc.cuerpo.cc_id_904=[];
            this.model.doc.cuerpo.cc_id_905=[];
            this.model.doc.cuerpo.cc_id_906=[];		
            this.model.doc.cuerpo.cc_id_907=[];	
            this.model.doc.cuerpo.cc_id_908=[];	
            this.model.doc.cuerpo.cc_id_909=[];	
            this.model.doc.cuerpo.cc_id_910=[];	
            this.model.doc.cuerpo.cc_id_911=[];	
            this.model.doc.cuerpo.cc_id_912=[];	
      
        this.model.doc.cuerpo.cs_id_548="0";//Indicador de Completo Otros Activos 
        break;
      case 4:
        this.model.doc.cuerpo.cs_id_492="0";
        this.model.doc.cuerpo.cs_id_493="0";
  //      this.model.doc.cuerpo.cs_id_663   ="0";
        this.model.doc.cuerpo.cs_id_549="0";//Indicador de Completo liquidacion 
        break;
      case 5:
        this.model.doc.cuerpo.cs_id_495="0";
        this.model.doc.cuerpo.cs_id_550="0";//Indicador de Completo prestamos
        //this.model.doc.cuerpo.cs_id_551="0";//Indicador de Completo deudas
        break;
      case 6          :
        this.model.doc.cuerpo.cs_id_497="0";
        this.model.doc.cuerpo.cs_id_551="0";//Indicador de Completo deudas
            
        break;
      case 7:
        this.model.doc.cuerpo.cs_id_499="0";
        this.model.doc.cuerpo.cs_id_552="0";//Indicador de Completo  REcompensa 
        break;  
      case 8:
        this.model.doc.cuerpo.cs_id_501="0";
        this.model.doc.cuerpo.cs_id_502="0";
        this.model.doc.cuerpo.cs_id_553="0";//Indicador de Completo indemnizaciones 
        break;
      case 9:
        this.model.doc.cuerpo.cs_id_804="0";
        this.model.doc.cuerpo.cs_id_715="0";    //Indicador de Completo hoteleras
        break;
      case 10:
        this.model.doc.cuerpo.cs_id_714="0";
        this.model.doc.cuerpo.cs_id_807="0";//Indicador de Completo otros ingresos 
        break;
      case 11:
        this.model.doc.cuerpo.cs_id_503=null;
        this.model.doc.cuerpo.cs_id_504="0";
        this.model.doc.cuerpo.cs_id_508="0";
        this.model.doc.cuerpo.cs_id_509="0";
        this.model.doc.cuerpo.cs_id_510="0";
        this.model.doc.cuerpo.cs_id_511="0";
        this.model.doc.cuerpo.cs_id_512="0";
        this.model.doc.cuerpo.cs_id_513=null;
        this.model.doc.cuerpo.cs_id_514="0";
        this.model.doc.cuerpo.cs_id_515="0";
        this.model.doc.cuerpo.cs_id_516="0";
        this.model.doc.cuerpo.cs_id_517="0";
        this.model.doc.cuerpo.cs_id_518="0";
        this.model.doc.cuerpo.cs_id_519="0";
        this.model.doc.cuerpo.cs_id_520="0";
        this.model.doc.cuerpo.cs_id_521="0";
        this.model.doc.cuerpo.cs_id_522="0";
        this.model.doc.cuerpo.cs_id_526="0";
        this.model.doc.cuerpo.cs_id_527="0";
        this.model.doc.cuerpo.cs_id_523="0";
        this.model.doc.cuerpo.cs_id_524="0";
        this.model.doc.cuerpo.cs_id_525="0";
        this.model.doc.cuerpo.cs_id_528=null;
        this.model.doc.cuerpo.cs_id_529="0";
          this.model.doc.cuerpo.cs_id_554="0";//Indicador de Completo reporto Otros ingresos 
          break;
    
  
        
  
    }
    console.log(this.model);
  }

  public validateComponentCompleted(): boolean{
    for(let i=0; i < questions.length; i++){
      if(questions[i].isCompleted==false){
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if(this.model.doc.cuerpo[data.field] == "0"){
      if(this.validateHasModalValues(index)){
        this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
          if (result) {
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateComponentCompleted();
            this.saveModel.emit(true);
          }else{
            this.model.doc.cuerpo[data.field] == "";
          }
        });
      }else{
        questions[index].isCompleted = true;
        this.cleanModalValues(index);
        this.saveModel.emit(true);
      }
    }else if (this.model.doc.cuerpo[data.field] == "1"){
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrandolo completo
      this.openModal(index);
      this.saveModel.emit(true);
      
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
    console.log(data);
    console.log(this.model);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/renta-no-laboral/renta-no-laboral.component.ts